import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setSharedAsics } from "../../state/MainSlice";
import { useCookies } from "react-cookie";
import SharedAsicCard from "./SharedAsicCard";
import NoShares from "./NoShares";

const SharedPage = () => {
  const sharedAsics = useSelector((state) => state.eph.main.sharedAsics);
  const [cookies, _setCookie, _removeCookie] = useCookies([]);
  const dispatch = useDispatch();
  const idToken = useSelector((state) => state.eph.main.idToken);
  const [empty, setEmpty] = useState(false);

  const getSharedAsics = async () => {
    const fetched_shared_asics = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/asic-shares/`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          csrftoken: cookies["csrftoken"],
          Authorization: "Bearer " + idToken,
        },
      }
    );
    const asicsJson = await fetched_shared_asics.json();
    asicsJson.length === 0 && setEmpty(true);
    dispatch(setSharedAsics(asicsJson));
  };

  useEffect(() => {
    idToken !== "" && getSharedAsics();
  }, [idToken]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box m="1rem" height="100%" sx={{ overflowY: "auto" }}>
      {empty ? (
        <NoShares />
      ) : (
        <Box
          display="grid"
          gap="1rem"
          gridTemplateColumns="repeat(auto-fill, minmax(20rem, 1fr))"
          m="1rem"
        >
          {sharedAsics.map((sharedAsic) => (
            <SharedAsicCard share={sharedAsic} key={sharedAsic.id_asic_share} />
          ))}
        </Box>
      )}
    </Box>
  );
};
export default SharedPage;
